import { render, staticRenderFns } from "./m-orm-forms-stepper-dialog.vue?vue&type=template&id=15b50dba&lang=pug&"
import script from "./m-orm-forms-stepper-dialog.vue?vue&type=script&lang=js&"
export * from "./m-orm-forms-stepper-dialog.vue?vue&type=script&lang=js&"
import style0 from "./m-orm-forms-stepper-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports